($ => {
        function initializeScrollTo() {
          const { hash } = window.location;
          if (
            $("body").is(
              ".page-node-type-blog, .page-node-type-page, .page-node-type-resource, .page-node-type-event, .page-node-type-jobpost, .page-node-type-legality-guides, .page-node-type-global-regulation-reports"
            ) &&
            hash.length > 0
          ) {
            setTimeout(() => {
              window.scrollTo(0, $(hash).offset().top - 92);
            }, 100);
          }

          $('a[href^="#"]', "body.page-node-type-blog .content").on(
            "click",
            e => {
              e.preventDefault();
              const elementToScroll = $(this).attr("href");
              if (elementToScroll.length) {
                window.scrollTo(0, $(elementToScroll).offset().top - 92);
              }
            }
          );
        }
        $(document).on("load", initializeScrollTo);

        // Store the currently active anchor link
        let activeAnchor = null;

        // Function to handle smooth scrolling with an offset and update the URL
        function scrollToAnchor(anchor) {
          // Find the target element with the specified ID
          const target = document.querySelector(anchor);

          // Check if the target exists or if it's the same as the active anchor, and return if so
          if (!target || target === activeAnchor) return;

          // Get the value of all body classes as a space-separated string
          const bodyClass = document.body.classList.value;

          // Find the sticky bar element
          const stickyBar = document.querySelector(".sticky-bar");

          // Calculate the sticky bar height or set a default value if the sticky bar doesn't exist
          const stickyBarHeight = stickyBar
            ? stickyBar.offsetHeight
            : 100;

          // Initialize a scroll offset variable
          let scrollOffset = 0;

          // Check if the body class includes "page-node-type-page"
          if (bodyClass.includes("page-node-type-page")) {
            // If logged in, use a scroll offset of 2, otherwise 1
            scrollOffset = document.body.classList.contains(
              "user-logged-in"
            )
              ? 2
              : 1;
          } else if (bodyClass.includes("page-node-type-blog")) {
            // If on a blog page, use a scroll offset of 1.5 if logged in, otherwise 1
            scrollOffset = document.body.classList.contains(
              "user-logged-in"
            )
              ? 1.5
              : 1.2;
          } else if (bodyClass.includes("page-node-type-document")) {
            // If on a document page, use a scroll offset of 1.5 if logged in, otherwise 1
            scrollOffset = document.body.classList.contains(
              "user-logged-in"
            )
              ? 1.7
              : 1.4;
          }

          // Calculate the final scroll position, adjusting for the sticky bar and scroll offset
          const scrollPosition =
            target.getBoundingClientRect().top +
            window.scrollY -
            stickyBarHeight * scrollOffset;

          // Scroll the page to the target position with smooth behavior
          window.scrollTo({ top: scrollPosition, behavior: "smooth" });

          // Update the active anchor link
          activeAnchor = target;
        }

        // Add click event listeners to anchor links in the sidebar
        const sidebarLinks = document.querySelectorAll(
          ".document-table-of-contents a"
        );
        sidebarLinks.forEach(link => {
          link.addEventListener("click", e => {
            // Prevent the default behavior of anchor links (page jump)
            e.preventDefault();
            // Scroll to the target section associated with the link's href
            scrollToAnchor(link.getAttribute("href"));
          });
        });
      })(jQuery);
